import React, { useState, useEffect } from "react";
import axios from "axios";
import { Alert } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { momentLocalizer } from "react-big-calendar";
import moment from "moment";
import { FaTrashAlt } from "react-icons/fa";
import { Header } from "./Header";
import { Footer } from "./Footer";

export const Roster = () => {
  const currentYear = new Date().getFullYear();
  const [emData, setData] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [activesIndex, setActivesIndex] = useState(null);
  const [gdata, getData] = useState("");
  const [valuegetUser, setValuegetuser] = useState([]);
  const [getallroster, setValuegetallroster] = useState([]);
  const [isClicked, setIsClicked] = useState(false);
  const [minisClicked, setMinClicked] = useState(false);
  const [locationID, setLocationId] = useState("");
  const [clientID, setClientId] = useState("");
  const [clientinfo, setclientInfo] = useState("");
  const [locatid, setlocatid] = useState("");
  const [isClickedloc, setIsClickedloc] = useState(false);
  const [clientreq, setclientreq] = useState(false);
  const [locatreq, setlocatreq] = useState(false);
  const [rosterreq, setrosterreq] = useState(false);
  const [located, setlocated] = useState("");
  const [rosters, setroster] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const apiurl = "https://jlmining.app/uploads/";
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    let month = today.getMonth() + 1;
    let day = today.getDate();

    // Add leading zero if month/day is a single digit
    month = month < 10 ? "0" + month : month;
    day = day < 10 ? "0" + day : day;

    return `${year}-${month}-${day}`;
  };
  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };
  const handleLogout = () => {
    localStorage.removeItem("users");
    window.location.href = "/login";
  };
  const handleSubmit = () => { };
  const handlechooseRoster = (type) => {
    setroster(type);
  };
  const checkcondition = () => {
    if (clientID === "") {
      setclientreq(true);
      return false;
    }
    if (locationID === "") {
      setlocatreq(true);
      return false;
    }
    if (selectedOption === "" || selectedOption === undefined) {
      setrosterreq(true);
      return false;
    }
    setrosterreq(false);
    setclientreq(false);
    setlocatreq(false);
  };
  const handlechooseRostersubmit = (event) => {
    if (clientID === "") {
      setclientreq(true);
      return false;
    }
    const userStr = JSON.parse(localStorage.getItem("users"));
    if (locationID === "") {
      setclientreq(true);
      return false;
    }
    if (selectedOption === "" || selectedOption === undefined) {
      setrosterreq(true);
      return false;
    }
    setclientreq(false);
    setlocatreq(false);
    var vl = event.target;
    console.log(vl.date.value);

    let formdata = {
      type: selectedOption,
      date: vl.date.value,
      locationId: locationID,
      clientID: clientID,
      user_id: userStr[0].id,
    };
    console.log(formdata);

    setrosterreq(false);
    setclientreq(false);
    setlocatreq(false);
    let formdsata = {
      user_id: userStr[0].id,
    };
    axios
      .post("https://jlmining.app/admin/setRoster", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log(res.data);
        if (res.data.status == "1") {
          setShowAlert(true);
          setShowAlert({ type: "error" });
          setTimeout(() => {
            setShowAlert(false);
          }, 4500);
        }
        if (res.data.status == "2") {
          setShowAlert(true);
          setShowAlert({ type: "success" });
          axios
            .post("https://jlmining.app/admin/getallrosters", formdsata, {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            })
            .then((res) => {
              var alldata = res.data.results;

              setValuegetallroster(alldata);
              setTimeout(() => {
                setShowAlert(false);
                window.location.reload();
              }, 4500);
            })
            .catch((err) => { });
        }
        if (res.data.status == "3") {
          setShowAlert(true);
          setShowAlert({ type: "errorroster" });
          setTimeout(() => {
            setShowAlert(false);
          }, 5500);
        }
        axios
          .post("https://jlmining.app/admin/getallrosters", formdata, {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          })
          .then((res) => {
            var alldata = res.data.results;

            setValuegetallroster(alldata);
          })
          .catch((err) => { });
      })
      .catch((err) => {
        //console.log(err.response.data);
      });
  };
  const localizer = momentLocalizer(moment);
  const navigate = useNavigate();
  const handlegetmnesites = (clientId, index) => {
    setActiveIndex(index);
    setActivesIndex("");
    setClientId(clientId);
    let formdata = {
      clientId: clientId,
    };
    axios
      .post("https://jlmining.app/admin/getminesites", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log(res.data.results);
        getData(res.data.results);
        setIsClicked(true);
        setMinClicked(false);
      })
      .catch((err) => { });
    axios
      .post("https://jlmining.app/admin/getclientinfo", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log(res.data.row);
        if (res.data.row != "") {
          setclientInfo(res.data.row[0]);
        }
      })
      .catch((err) => { });
  };
  const deleterotser = (id) => {
    var id = id;

    let roster = {
      id: id,
    };
    const userStr = JSON.parse(localStorage.getItem("users"));
    if (userStr === null) {
      window.location.href = "#/login";
    }
    let formdata = {
      user_id: userStr[0].id,
    };
    const del = window.confirm("Are you sure you want to delete this roster?");
    if (del) {
      axios
        .post("https://jlmining.app/admin/deleteroster", roster, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          axios
            .post("https://jlmining.app/admin/getallrosters", formdata, {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            })
            .then((res) => {
              var alldata = res.data.results;

              setShowAlert(true);
              setShowAlert({ type: "errordelete" });
              setTimeout(() => {
                setShowAlert(false);
              }, 4500);

              setValuegetallroster(alldata);
            })
            .catch((err) => { });
        })
        .catch((err) => { });
    }
  };
  const handlegetmoinesites = (locationId, index) => {
    var locationId = locationId;
    console.log(locationId);
    setActivesIndex(index);
    setlocatid(locationId);
    setMinClicked(true);
    setLocationId(locationId);
    setIsClickedloc(true);
    let location_Id = {
      locationId: locationId,
    };
    axios
      .post("https://jlmining.app/admin/getlocationr", location_Id, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log(res.data.ss);
        if (res.data.ss != "") {
          setlocated(res.data.ss);
        }
      })
      .catch((err) => { });
  };
  const changeFavicon = (url) => {
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon) {
      favicon.href = url;
    }
  };
  useEffect(() => {
    changeFavicon(require("./assets/admin/images/f-icon.png"));
    document.title = "Roster Page";
    const userStr = JSON.parse(localStorage.getItem("users"));
    if (!userStr) {
      navigate("/login");
    }
    let formdata = {
      user_id: userStr[0].id,
    };
    axios
      .post("https://jlmining.app/admin/getuserdetails", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        var alldata = res.data.row[0];

        setValuegetuser(alldata);
      })
      .catch((err) => { });
    axios
      .post("https://jlmining.app/admin/getallrosters", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        var alldata = res.data.results;

        setValuegetallroster(alldata);
      })
      .catch((err) => { });
    axios
      .get("https://jlmining.app/admin/getclient", {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log("ss");
        console.log(res.data.results);
        setData(res.data.results);
      })
      .catch((err) => { });
  }, []);
  const [values, setValues] = useState({
    name: "",
    email: "",
    password: "",
    contact: "",
    address: "",
  });
  const [showAlert, setShowAlert] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [val, setVal] = useState("");
  const handleInput = (event) => {
    setVal((v) => (event.target.validity.valid ? event.target.value : v));
    setValues((prev) => ({
      ...prev,
      [event.target.name]: [event.target.value],
    }));
  };

  const events = [
    {
      title: "Event 1",
      start: new Date(2023, 6, 11),
      end: new Date(2023, 6, 12),
    },
    // Add more events as needed
  ];

  var imageUrl = `${apiurl}${valuegetUser.image}`;
  if (valuegetUser.image == null) {
    var im = "male-upload.png";
    var imageUrl = `${apiurl}${im}`;
  } else {
    var imageUrl = `${apiurl}${valuegetUser.image}`;
  }
  console.log("s");
  console.log(imageUrl);
  const fname = valuegetUser.first_name;
  const mname = valuegetUser.middle_name;
  const lname = valuegetUser.last_name;
  const fLetter = fname ? fname.charAt(0) : "";
  const mLetter = mname ? mname.charAt(0) : "";
  const lLetter = lname ? lname.charAt(0) : "";
  return (
    <>
      <Header />
      <section className="innerbanner text-center py-5 d-block">
        <div className="container-lg">
          <h3 className="fs-30 fw-800 text-white">Select Roster</h3>
        </div>
      </section>
      <section className="profile-box text-center d-block pb-5 ">
        <div className="container-lg">
          <div className="row gy-4">
            <div className="col-lg-3">
              <div className="d-flex flex-column">
                <div className="d-flex flex-column gap-2 text-center pic-emp">
                  <div className="emplo-box-pic ofit mx-auto">
                    <img src={imageUrl} alt="image" />
                  </div>
                  <div className="d-flex flex-column">
                    <h3 className="fs-26 text-black fw-800">
                      {valuegetUser.first_name} {valuegetUser.middle_name}{" "}
                      {valuegetUser.last_name}
                    </h3>
                    <h4 className="fs-18 text-black">{valuegetUser.role}</h4>
                    {/* <p className="fs-12 text-black">{valueUserDetail.firstname}</p> */}
                  </div>
                </div>
                <div className="d-block red-heading bg-white shadow py-4 mt-auto">
                  {clientreq && (
                    <Alert
                      type="error"
                      description="This field is required"
                      closable
                    />
                  )}
                  <h3 className="mb-3">Select Client</h3>
                  <div className="over-empl">
                    <div className="d-flex flex-column h-100 clientselectmain">
                      {Array.isArray(emData) ? (
                        emData.map((item, index) => (
                          <Link
                            to="javascript:void(0)"
                            key={index}
                            className={`item ${activeIndex === index ? "active" : ""
                              }`}
                            onClick={() => handlegetmnesites(item.id, index)}
                          >
                            {item.name}
                          </Link>
                        ))
                      ) : (
                        <Link>No data available</Link>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3">
              <div className="d-flex flex-column h-100">
                <div className="d-block red-heading bg-white shadow py-4 mt-auto">
                  {locatreq && (
                    <Alert
                      type="error"
                      description="This field is required"
                      closable
                    />
                  )}
                  <h3 className="mb-3">Mine Sites</h3>
                  <div className="over-empl">
                    <div className="d-flex flex-column h-100 minestone">
                      {Array.isArray(gdata) ? (
                        gdata.map((item, index) => (
                          <Link
                            to="javascript:void(0)"
                            key={index}
                            className={`item ${activesIndex === index ? "active" : ""
                              }`}
                            onClick={() => handlegetmoinesites(item.id, index)}
                          >
                            {item.location_name}
                          </Link>
                        ))
                      ) : (
                        <Link>No data available</Link>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="d-flex flex-column h-100">
                <form
                  className="mt-auto"
                  action="javascript:void(0)"
                  onSubmit={handlechooseRostersubmit}
                  method="post"
                >
                  {showAlert?.type === "error" && (
                    <Alert
                      type="error"
                      description="You have no permission to add this roster!"
                      closable
                    />
                  )}
                  {showAlert?.type === "errorroster" && (
                    <Alert
                      type="error"
                      description="You have no permission to add this roster,because your location duration date in expire!."
                      closable
                    />
                  )}
                  {showAlert?.type === "success" && (
                    <Alert
                      type="success"
                      description="Roster has been successfully created!"
                      closable
                    />
                  )}
                  <div className="d-block red-heading bg-white shadow py-4">
                    <h3 className="mb-3">Remove Rosters</h3>
                    <div className="d-block num-block-box">
                      <div className="d-flex flex-row h-100 gap-3 roast-sel justify-content-center">
                        <div className="d-flex flex-column gap-3">
                          {Array.isArray(getallroster) ? (
                            getallroster.map((item, index) => (
                              <div className="d-flex px-3 gap-4 align-items-center">
                                <div>
                                  <h6>({item.type})</h6>
                                </div>
                                <div className="">
                                  <button
                                    className="border-0 bg-danger text-white py-1 px-2 fs-14"
                                    onClick={() => deleterotser(item.id)}
                                    type="button"
                                  >
                                    <FaTrashAlt />
                                  </button>
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="d-flex px-3 gap-4 align-items-center">
                              No data available
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    {rosterreq && (
                      <Alert
                        type="error"
                        description="This field is required"
                        closable
                      />
                    )}
                    <h3 className="mb-3 mt-3">Select Rosters</h3>
                    <div className="d-block num-block-box">
                      <div className="d-flex flex-row h-100 gap-3 roast-sel justify-content-center">
                        <div className="innerradio">
                          <label for="1">
                            <input
                              id="1"
                              required
                              name="selroaster"
                              checked={selectedOption === "2/2"}
                              onChange={handleOptionChange}
                              type="radio"
                              value="2/2"
                            />
                            <p> 2/2</p>
                            <span class="checkmark"></span>
                          </label>
                        </div>
                        <div className="innerradio">
                          <label for="2">
                            <input
                              id="2"
                              checked={selectedOption === "3/1"}
                              onChange={handleOptionChange}
                              name="selroaster"
                              type="radio"
                              value="3/1"
                            />
                            <p> 3/1</p>
                            <span class="checkmark"></span>
                          </label>
                        </div>
                        <div className="innerradio">
                          <label for="3">
                            <input
                              id="3"
                              checked={selectedOption === "8/6"}
                              onChange={handleOptionChange}
                              name="selroaster"
                              type="radio"
                              value="8/6"
                            />
                            <p> 8/6 </p>
                            <span class="checkmark"></span>
                          </label>
                        </div>
                        <div className="innerradio">
                          <label for="4">
                            <input
                              id="4"
                              checked={selectedOption === "2/1"}
                              onChange={handleOptionChange}
                              name="selroaster"
                              type="radio"
                              value="2/1"
                            />
                            <p> 2/1 </p>
                            <span class="checkmark"></span>{" "}
                          </label>
                        </div>
                        <div className="innerradio">
                          <label for="5">
                            <input
                              id="5"
                              checked={selectedOption === "15/13"}
                              onChange={handleOptionChange}
                              name="selroaster"
                              type="radio"
                              value="15/13"
                            />
                            <p> 15/13</p>
                            <span class="checkmark"></span>{" "}
                          </label>
                        </div>
                        <div className="innerradio">
                          <label for="6">
                            <input
                              id="6"
                              checked={selectedOption === "7/7"}
                              onChange={handleOptionChange}
                              name="selroaster"
                              type="radio"
                              value="7/7"
                            />
                            <p> 7/7</p>
                            <span class="checkmark"></span>{" "}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex justify-content-between mt-4">
                    <div class="form-box formbox">
                      <label className="text-left mb-2">Choose Date</label>
                      <input
                        type="date"
                        name="date"
                        min={getCurrentDate()}
                        required
                      />
                    </div>
                    <div className="mt-4">
                      <button
                        type="submit"
                        onClick={() => checkcondition()}
                        className="submit-btn"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="row gy-4 mt-2">
            {/* <div className="col-lg-2 mt-4">
                      <div className="d-block red-heading bg-white shadow py-4 mt-auto">
                        <h3 className="mb-3">Remove Roster</h3>
                        {showAlert?.type === "errordelete" && (
                        <Alert
                          type="errordelete"
                          description="Delete successfully!"
                          closable
                        />
                      )}
                        <div className="over-empl h-80">
                          <div className="d-flex flex-column gap-3">
                          {Array.isArray(getallroster) ? (
                              getallroster.map((item, index) => (
                                <div className="d-flex px-3 gap-4 align-items-center">
                                  <div><h6>({item.type})</h6></div>
                                  <div className=""><button className="border-0 bg-danger text-white py-1 px-2 fs-14" onClick={() =>
                                    deleterotser(item.id)
                                  } type="button"><FaTrashAlt/></button></div>

                                </div>
                              ))
                            ) : (
                              <div className="d-flex px-3 gap-4 align-items-center">No data available</div>
                            )}




                          </div>
                        </div>
                      </div>
                    </div> */}

            {isClicked && (
              <div className="col-lg-6 mt-4">
                <div className="right-form-box bg-white shadow p-4">
                  <div className="row gap-2">
                    <div className="col-12 col-lg-8">
                      <div className="d-flex justify-content-between p-2">
                        <label for="">Client Name:-</label>
                        <span className="fs-14">{clientinfo.name}</span>
                      </div>

                      <div className="d-flex justify-content-between p-2">
                        <label for="">Position:-</label>
                        <span className="fs-14">{clientinfo.position}</span>
                      </div>
                      <div className="d-flex justify-content-between p-2">
                        <label for="">Department:-</label>
                        <span className="fs-14">{clientinfo.department}</span>
                      </div>
                      <div className="d-flex justify-content-between p-2">
                        <label for="">Work Phone Number:-</label>
                        <span className="fs-14">{clientinfo.phone_number}</span>
                      </div>
                      <div className="d-flex justify-content-between p-2">
                        <label for="">Mobile Phone Number:-</label>
                        <span className="fs-14">
                          {clientinfo.mobile_number}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between p-2">
                        <label for="">Home Phone Number:-</label>
                        <span className="fs-14">
                          {clientinfo.home_phone_number}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between p-2">
                        <label for="">Fax Number:-</label>
                        <span className="fs-14">{clientinfo.fax_number}</span>
                      </div>
                      <div className="d-flex justify-content-between p-2">
                        <label for="">Email-Id:-</label>
                        <span className="fs-14">{clientinfo.email}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {isClickedloc && (
              <div className="col-lg-6 mt-4">
                <div className="right-form-box bg-white shadow p-4">
                  <div className="row gap-2">
                    <div className="col-12 col-lg-8">
                      <div className="d-flex justify-content-between p-2">
                        <label for="">Location Name:-</label>
                        <span className="fs-14">{located.location_name}</span>
                      </div>

                      <div className="d-flex justify-content-between p-2">
                        <label for="">Nearest Town:-</label>
                        <span className="fs-14">{located.nearest_town}</span>
                      </div>
                      <div className="d-flex justify-content-between p-2">
                        <label for="">Commodity:-</label>
                        <span className="fs-14">{located.commodity}</span>
                      </div>
                      <div className="d-flex justify-content-between p-2">
                        <label for="">Contract Type:-</label>
                        <span className="fs-14">{located.contract_type}</span>
                      </div>
                      <div className="d-flex justify-content-between p-2">
                        <label for="">Duration Start:-</label>
                        <span className="fs-14">{located.duration_start}</span>
                      </div>
                      <div className="d-flex justify-content-between p-2">
                        <label for="">Duration End:-</label>
                        <span className="fs-14">{located.duration_end}</span>
                      </div>
                      <div className="d-flex justify-content-between p-2">
                        <label for="">Scope:-</label>
                        <span className="fs-14">{located.scope}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};
